import { Base } from './base';
import '@gnyio/interfaces';
import '../connection';
export class Account {
    constructor(connection) {
        this.base = new Base(connection);
    }
    async openAccount(publicKey) {
        const res = await this.base.post('/api/accounts/openAccount', {
            publicKey: publicKey,
        });
        const result = res.data;
        return result;
    }
    async getBalance(address) {
        const params = { address: address };
        const res = await this.base.get('/api/accounts/getBalance', params);
        const result = res.data;
        return result;
    }
    async getAddressCurrencyBalance(address, currency) {
        const res = await this.base.get(`/api/accounts/${address}/${currency}`);
        const result = res.data;
        return result;
    }
    async getAccountByAddress(address) {
        const params = { address: address };
        const res = await this.base.get('/api/accounts/', params);
        const result = res.data;
        return result;
    }
    async getAccountByUsername(username) {
        const params = { username: username };
        const res = await this.base.get('/api/accounts/', params);
        const result = res.data;
        return result;
    }
    async getVotedDelegates(query) {
        const res = await this.base.get('/api/accounts/getVotes', query);
        const result = res.data;
        return result;
    }
    async countAccounts() {
        const res = await this.base.get('/api/accounts/count');
        const result = res.data;
        return result;
    }
    async getPublicKey(address) {
        const params = {
            address: address,
        };
        const res = await this.base.get('/api/accounts/getPublicKey', params);
        const result = res.data;
        return result;
    }
}
//# sourceMappingURL=account.js.map